import { buildDateRangeFilters, mergeFilters } from '@/ui/composites/grid/gridFilters';
import type { GridQueryInput } from '@/ui/composites/grid/gridUtils';

type GridFilters = GridQueryInput['filters'];

type BuildDeliveryPageFiltersInput = {
  rangeStartIso: string | null;
  rangeEndIso: string | null;
  previousRangeStartIso: string | null;
  previousRangeEndIso: string | null;
  statusFilters: GridFilters;
  tagFilters: GridFilters;
  projectFilters: GridFilters;
};

export const buildDeliveryPageFilters = ({
  rangeStartIso,
  rangeEndIso,
  previousRangeStartIso,
  previousRangeEndIso,
  statusFilters,
  tagFilters,
  projectFilters,
}: BuildDeliveryPageFiltersInput): {
  currentDateFilters: GridFilters;
  previousDateFilters: GridFilters;
  summaryFilters: GridFilters;
  previousSummaryFilters: GridFilters;
} => {
  const currentDateFilters = buildDateRangeFilters(
    'deliveryDateWindow',
    rangeStartIso,
    rangeEndIso,
  );
  const previousDateFilters = buildDateRangeFilters(
    'deliveryDateWindow',
    previousRangeStartIso,
    previousRangeEndIso,
  );

  return {
    currentDateFilters,
    previousDateFilters,
    summaryFilters: mergeFilters(currentDateFilters, statusFilters, tagFilters, projectFilters),
    previousSummaryFilters: mergeFilters(
      previousDateFilters,
      statusFilters,
      tagFilters,
      projectFilters,
    ),
  };
};
